// Podatki izdelkov za kiosk. Vir: heka-interior.si (/products/<handle>.js in opisi strani, 1. 11. 2026)
// in brošura 2026-11-01 (8 strani). Brez izmišljenih podatkov: kar ni preverjeno, ni zapisano.
window.PRODUCTS = [
  {
    id: "corestack",
    name: "CoreStack",
    kind: "Omare in police",
    line: "Modularne omare, police in osebne omarice. Izdelava v Medvodah.",
    tileImg: "img/corestack.jpg",
    tileFit: "contain",
    // konfigurator: stran izdelka; tip omare izberete v konfiguratorju
    path: "/products/corestack-omara-s-krilnimi-vrati-v4",
    keep: '[id$="__main"]',
    hint: "Tip omare, višino, širino, dekor, ročaj in podnožje izberete desno od modela. Model zavrtite s prstom.",
    facts: [
      ["Tipi", "11 tipov omar in polic"],
      ["Višine", "1 do 6 vrst, vrsta 35,2 cm"],
      ["Širine", "400 do 1600 mm"],
      ["Plošča", "Iverna 18 mm, melamin"],
    ],
    // izbira brez povezave (iz možnosti v trgovini)
    offline: [
      { key: "Tip", values: ["Omara z vrati", "Omara z drsnimi vrati", "Kombinirana omara", "Omara s predali", "Odprta polica", "Garderobna omara", "Odprta garderoba", "Omara z nišo", "Osebne omarice"] },
      { key: "Dekor", values: ["Bela W1000", "Svetlo siva U708", "Črna U999", "Hrast Vicenza H3157", "Kašmir U702"] },
      { key: "Ročaj", values: ["Črn mat", "Aluminij", "Brez ročaja"] },
      { key: "Podnožje", values: ["Nivelirne nogice", "Kovinske noge", "Kovinski cokel", "Cokel v dekorju"] },
    ],
  },
  {
    id: "corelift",
    name: "CoreLift",
    kind: "Dvižne mize",
    line: "Električna dvižna miza z dvema motorjema in spominom višine.",
    tileImg: "img/corelift.jpg",
    tileFit: "contain",
    path: "/products/corelift",
    keep: '[id$="__main-configurator"]',
    capture: "corelift",
    hint: "Velikost plošče, dekor in barvo podnožja izberete ob modelu. Model zavrtite s prstom.",
    facts: [
      ["Dolžina", "120–200 cm"],
      ["Globina", "70–90 cm"],
      ["Pogon", "Dva motorja, spomin višine"],
      ["Podnožje", "Bela, siva, črna"],
      ["Plošča", "Iveral, furnir ali masiva hrast"],
    ],
    offline: [
      { key: "Dolžina", values: ["120 cm", "130 cm", "140 cm", "150 cm", "160 cm", "170 cm", "180 cm", "190 cm", "200 cm"] },
      { key: "Globina", values: ["70 cm", "75 cm", "80 cm", "85 cm", "90 cm"] },
      { key: "Podnožje", values: ["Bela", "Siva", "Črna"] },
      { key: "Plošča", values: ["Iveral bela", "Iveral hrast Vicenza", "Iveral siva", "Iveral črna", "Furnir hrast", "Masiva hrast"] },
    ],
  },
  {
    id: "mirage",
    name: "Mirage",
    kind: "Pohištvo po meri",
    line: "Mize, omare in predalniki iz furnirja po meri. Lastna proizvodnja v Medvodah.",
    tileImg: "img/mirage.jpg",
    tileFit: "cover",
    gallery: ["img/mirage.jpg", "img/mirage_kos.jpg"],
    path: "/products/mirage-2",
    noConfigurator: true,
    facts: [
      ["Izvedba", "Po meri, za pisarne in sejne sobe"],
      ["Materiali", "Furnir, lakirano motno steklo, eloksiran aluminij, usnje"],
      ["Notranjost", "Plošče iz stisnjenih vlaken (notranjost omar, predelki)"],
    ],
    offline: [
      { key: "Kosi", multi: true, values: ["Delovna miza", "Sejna miza", "Omare", "Predalniki"] },
    ],
  },
  {
    id: "planer",
    name: "Planer pisarne",
    kind: "3D planer",
    line: "Prostor narišete, postavite mize, omare in stole, pogledate v 3D in dobite tloris v merilu s kosovnico.",
    tileImg: "img/planer.jpg",
    tileFit: "cover",
    path: "/pages/planer-pisarne",
    keep: null, // lastna postavitev brez glave in noge
    noPaket: true, // planer ima svoj izvoz in povpraševanje; v paket gre samo kot zanimanje prek obrazca
    wide: true,
    facts: [
      ["Prostor", "Tloris narišete ali izberete predlogo"],
      ["Kosi", "Mize, omare CoreStack, stoli in akustika Heka"],
      ["Izhod", "Tloris v merilu in kosovnica"],
    ],
    offline: [
      { key: "Prostor", values: ["Odprti prostor", "Sejna soba", "Direktorska pisarna", "Domača pisarna"] },
    ],
  },
];
